import styles from '@components/components/CmsComponents/components/CmsSubCategories/CmsSubCategories.module.scss';
import React from 'react';
import {
  Accordion,
  AccordionGroup,
  Heading,
  Link,
} from '@wienenergiegithub/ui-next';

const CmsSubCategories = ({ items }) => (
  <AccordionGroup defaultOpenIndex={0}>
    {items.map(({ title, links, id }) => (
      <Accordion key={id} title={title}>
        {links.map(item => (
          <Heading
            as={Link}
            className={styles.link}
            key={item.id}
            size="h7"
            to={item.url}
          >
            {item.title}
          </Heading>
        ))}
      </Accordion>
    ))}
  </AccordionGroup>
);

export default CmsSubCategories;
